<template>
  <div class="featured-works">
    <!-- 头部 -->
    <div class="fw-head">
      <span class="fw-label">优秀作品</span>
      <span class="fw-refresh" @click="refresh">
        <svg viewBox="0 0 24 24" width="13" height="13" style="vertical-align:-2px;margin-right:3px">
          <path fill="currentColor" d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
        </svg>换一换
      </span>
    </div>

    <!-- 骨架屏 -->
    <div v-if="loading" class="fw-grid">
      <div v-for="i in 4" :key="i" class="fw-skeleton"></div>
    </div>

    <!-- 图片 / 视频 网格 -->
    <template v-else-if="cateId !== 103">
      <div v-if="items.length" class="fw-grid">
        <div
          v-for="(item, i) in items"
          :key="i"
          class="fw-cell"
          @click="handleClick(item)"
        >
          <img :src="getCover(item)" class="fw-thumb" alt="" />
          <div class="fw-cell-mask">
            <div v-if="cateId === 102" class="fw-cell-play">
              <svg viewBox="0 0 24 24" width="28" height="28">
                <path fill="rgba(255,255,255,0.92)" d="M8 5v14l11-7z"/>
              </svg>
            </div>
            <!-- <span class="fw-cell-user">{{ item.user_name }}</span> -->
          </div>
        </div>
      </div>
      <div v-else class="fw-empty">暂无优秀作品</div>
    </template>

    <!-- 音乐网格 -->
    <template v-else>
      <div v-if="items.length" class="fw-grid">
        <div
          v-for="(item, i) in items"
          :key="i"
          :class="['fw-cell', { 'fw-cell-playing': isCurrentPlaying(item) }]"
          @click="handleClick(item)"
        >
          <div class="fw-music-bg" :style="{ background: getMusicCoverBg(item) }"></div>
          <div class="fw-cell-mask fw-cell-mask-always">
            <div class="fw-cell-play">
              <svg v-if="!isCurrentPlaying(item)" viewBox="0 0 24 24" width="28" height="28">
                <path fill="rgba(255,255,255,0.92)" d="M8 5v14l11-7z"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" width="28" height="28">
                <path fill="rgba(255,255,255,0.92)" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
              </svg>
            </div>
            <span class="fw-cell-music-title">{{ getMusicTitle(item) }}</span>
          </div>
        </div>
      </div>
      <div v-else class="fw-empty">暂无优秀作品</div>
    </template>

    <!-- ─── 图片灯箱 ─── -->
    <div v-if="lightbox.visible" class="fw-overlay" @click.self="closeLightbox">
      <div class="fw-lb-wrap">
        <div class="fw-lb-img-box">
          <img
            :src="lightbox.url"
            class="fw-lb-img"
            :style="{ transform: `scale(${lightbox.scale}) rotate(${lightbox.rotation}deg)` }"
            alt=""
          />
        </div>
        <div class="fw-lb-toolbar">
          <button class="fw-lb-btn" @click="lbZoomIn" title="放大">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2V7z"/></svg>
            <span>放大</span>
          </button>
          <button class="fw-lb-btn" @click="lbZoomOut" title="缩小">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"/></svg>
            <span>缩小</span>
          </button>
          <button class="fw-lb-btn" @click="lbRotate" title="旋转">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L9.95 21.4l-2.48.09zM12.05 0c-.23 0-.44.02-.66.03l2.66 2.56 2.48-.09C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zm-1.39 9.03c-1.65.59-2.73 2.3-2.43 4.12.33 2.01 2.21 3.37 4.22 3.04 1.65-.27 2.9-1.62 3.07-3.19H14c-.15.86-.82 1.57-1.72 1.72-1.19.2-2.31-.61-2.52-1.8-.2-1.17.6-2.29 1.77-2.51.51-.1 1.01-.01 1.43.23l-1.27 1.27 3.94.4-.4-3.94-1.27 1.27c-.72-.43-1.57-.64-2.3-.61z"/></svg>
            <span>旋转</span>
          </button>
          <button class="fw-lb-btn" @click="lbDownload" title="下载">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z"/></svg>
            <span>下载</span>
          </button>
          <button class="fw-lb-btn fw-btn-same" @click="useSame" title="做同款">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>
            <span>做同款</span>
          </button>
          <button class="fw-lb-btn fw-btn-close" @click="closeLightbox" title="关闭">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
            <span>关闭</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ─── 视频播放器 ─── -->
    <div v-if="videoPlayer.visible" class="fw-overlay" @click.self="closeVideoPlayer">
      <div class="fw-video-wrap">
        <video :src="videoPlayer.url" controls autoplay class="fw-video"></video>
        <div class="fw-video-toolbar">
          <button class="fw-lb-btn fw-btn-same" @click="useSame" title="做同款">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>
            <span>做同款</span>
          </button>
          <button class="fw-lb-btn" @click="vpDownload" title="下载">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z"/></svg>
            <span>下载</span>
          </button>
          <button class="fw-lb-btn fw-btn-close" @click="closeVideoPlayer" title="关闭">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
            <span>关闭</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ─── 隐藏 audio（仅音乐模式）─── -->
    <audio
      v-if="cateId === 103"
      ref="fwAudio"
      :src="currentTrack ? currentTrack.url : ''"
      @timeupdate="onTimeUpdate"
      @loadedmetadata="onLoadedMetadata"
      @ended="onAudioEnded"
      style="display:none"
    ></audio>

    <!-- ─── 右下角迷你播放器（音乐模式）─── -->
    <div v-if="currentTrack" class="fw-mini-player">
      <div class="fw-mini-cover" :style="{ background: currentTrack.cover || 'linear-gradient(135deg,#1a1a2e,#7b2ff7)' }">
        <svg v-if="!isPlaying" viewBox="0 0 24 24" width="14" height="14"><path fill="#fff" d="M8 5v14l11-7z"/></svg>
        <svg v-else viewBox="0 0 24 24" width="14" height="14"><path fill="#fff" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
      </div>
      <div class="fw-mini-body">
        <div class="fw-mini-title">{{ currentTrack.title }}</div>
        <div class="fw-mini-progress" @click="seekTo">
          <div class="fw-mini-fill" :style="{ width: duration ? (currentTime / duration * 100) + '%' : '0%' }"></div>
        </div>
        <div class="fw-mini-times">
          <span>{{ formatTime(currentTime) }}</span>
          <span>{{ formatTime(duration) }}</span>
        </div>
      </div>
      <div class="fw-mini-actions">
        <button class="fw-mini-btn" @click="togglePlayCurrent">
          <svg v-if="!isPlaying" viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>
          <svg v-else viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
        </button>
        <button class="fw-mini-btn" @click="downloadCurrentTrack" title="下载">
          <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z"/></svg>
        </button>
        <button class="fw-mini-btn fw-mini-btn-close" @click="stopPlayer" title="关闭">
          <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturedWorks',
  props: {
    cateId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      page: 1,
      lightbox: { visible: false, url: '', scale: 1, rotation: 0, prompt: '' },
      videoPlayer: { visible: false, url: '', prompt: '' },
      currentTrack: null,
      isPlaying: false,
      currentTime: 0,
      duration: 0,
    };
  },
  created() {
    this.load();
  },
  beforeDestroy() {
    if (this.$refs.fwAudio) {
      this.$refs.fwAudio.pause();
    }
  },
  methods: {
    /* ─── 数据获取 ─── */
    load() {
      this.loading = true;
      this.$http.get('/front/aipkai/pieces/', {
        // params: { is_history:0, cate_id: this.cateId, sort: 2, size: 4, is_info: 1, page: this.page, is_curated: 1},
        params: {watermark_text: this.cateId == 101 || this.cateId == 102 ?"标营AI生成" : "", is_history:1, cate_id: this.cateId, sort: 2, size: 4, is_info: 1, page: this.page, is_curated: 1},
      }).then(res => {
        this.loading = false;
        if (res && res.data) {
          if (res.data.item_list.length === 0 && this.page > 1) {
            this.page = 1;
            this.load();
          } else {
          this.items = res.data.item_list || [];
        }}
      }).catch(() => {
        this.loading = false;
      });
    },
    refresh() {
      this.page = this.page >= 5 ? 1 : this.page + 1;
      this.load();
    },

    /* ─── 数据提取辅助 ─── */
    getCover(item) {
      const out = item.output_json || {};
      return out.cdn_cover_url || out.cover_url || out.cdn_url || out.url || '';
    },
    getFullUrl(item) {
      const out = item.output_json || {};
      return out.cdn_url || out.url || '';
    },
    getVideoUrl(item) {
      const out = item.output_json || {};
      return out.cdn_url || out.url || '';
    },
    getPrompt(item) {
      const inj = item.input_json || {};
      return inj.prompt || inj.text || item.keywords || '';
    },
    // 从单个 ai_task item 解析出首条音乐信息
    getMusicTrack(item) {
      const out = item.output_json || {};
      const input = item.input_json || {};
      if (Array.isArray(out.tracks) && out.tracks.length) {
        return out.tracks[0];
      }
      return {
        title: input.prompt || item.keywords || '音乐',
        styleDesc: out.style || '',
        cover: out.cover || 'linear-gradient(135deg,#1a1a2e,#7b2ff7)',
        url: out.cdn_url || out.url || '',
      };
    },
    getMusicUrl(item) {
      return this.getMusicTrack(item).url;
    },
    getMusicTitle(item) {
      return this.getMusicTrack(item).title;
    },
    getMusicCoverBg(item) {
      const track = this.getMusicTrack(item);
      return track.cover || 'linear-gradient(135deg,#1a1a2e,#7b2ff7)';
    },
    isCurrentPlaying(item) {
      return this.currentTrack && this.currentTrack.url === this.getMusicUrl(item) && this.isPlaying;
    },

    /* ─── 点击分发 ─── */
    handleClick(item) {
      if (this.cateId === 101) {
        this.openLightbox(item);
      } else if (this.cateId === 102) {
        this.openVideoPlayer(item);
      } else if (this.cateId === 103) {
        this.togglePlay(item);
      }
    },

    /* ─── 图片灯箱 ─── */
    openLightbox(item) {
      this.lightbox = {
        visible: true,
        url: this.getFullUrl(item),
        scale: 1,
        rotation: 0,
        prompt: this.getPrompt(item),
      };
    },
    closeLightbox() {
      this.lightbox.visible = false;
    },
    lbZoomIn() {
      this.lightbox.scale = Math.min(4, +(this.lightbox.scale + 0.25).toFixed(2));
    },
    lbZoomOut() {
      this.lightbox.scale = Math.max(0.25, +(this.lightbox.scale - 0.25).toFixed(2));
    },
    lbRotate() {
      this.lightbox.rotation = (this.lightbox.rotation + 90) % 360;
    },
    lbDownload() {
      const a = document.createElement('a');
      a.href = this.lightbox.url;
      a.download = 'image';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    /* ─── 视频播放器 ─── */
    openVideoPlayer(item) {
      this.videoPlayer = {
        visible: true,
        url: this.getVideoUrl(item),
        prompt: this.getPrompt(item),
      };
    },
    closeVideoPlayer() {
      this.videoPlayer.visible = false;
    },
    vpDownload() {
      const a = document.createElement('a');
      a.href = this.videoPlayer.url;
      a.download = 'video';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    /* ─── 做同款 ─── */
    useSame() {
      const prompt = this.lightbox.visible
        ? this.lightbox.prompt
        : this.videoPlayer.prompt;
      this.$emit('use-prompt', prompt);
      this.closeLightbox();
      this.closeVideoPlayer();
    },

    /* ─── 音乐播放 ─── */
    togglePlay(item) {
      const track = this.getMusicTrack(item);
      if (!track.url) return;
      const audio = this.$refs.fwAudio;
      if (this.currentTrack && this.currentTrack.url === track.url) {
        if (this.isPlaying) {
          audio.pause();
          this.isPlaying = false;
        } else {
          audio.play();
          this.isPlaying = true;
        }
      } else {
        this.currentTrack = track;
        this.currentTime = 0;
        this.duration = 0;
        this.isPlaying = false;
        this.$nextTick(() => {
          audio.load();
          audio.play().then(() => { this.isPlaying = true; }).catch(() => {});
        });
      }
    },
    togglePlayCurrent() {
      const audio = this.$refs.fwAudio;
      if (this.isPlaying) {
        audio.pause();
        this.isPlaying = false;
      } else {
        audio.play().then(() => { this.isPlaying = true; }).catch(() => {});
      }
    },
    stopPlayer() {
      const audio = this.$refs.fwAudio;
      if (audio) audio.pause();
      this.isPlaying = false;
      this.currentTrack = null;
      this.currentTime = 0;
      this.duration = 0;
    },
    onTimeUpdate() {
      this.currentTime = this.$refs.fwAudio ? this.$refs.fwAudio.currentTime : 0;
    },
    onLoadedMetadata() {
      this.duration = this.$refs.fwAudio ? this.$refs.fwAudio.duration : 0;
    },
    onAudioEnded() {
      this.isPlaying = false;
      this.currentTime = 0;
    },
    seekTo(e) {
      const audio = this.$refs.fwAudio;
      if (!audio || !this.duration) return;
      const rect = e.currentTarget.getBoundingClientRect();
      audio.currentTime = ((e.clientX - rect.left) / rect.width) * this.duration;
    },
    formatTime(s) {
      if (!s || isNaN(s)) return '0:00';
      const m = Math.floor(s / 60);
      const sec = Math.floor(s % 60);
      return `${m}:${String(sec).padStart(2, '0')}`;
    },
    downloadCurrentTrack() {
      if (!this.currentTrack) return;
      const a = document.createElement('a');
      a.href = this.currentTrack.url;
      a.download = (this.currentTrack.title || 'music') + '.mp3';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>

<style lang="scss" scoped>
.featured-works {
  width: 100%;
  max-width: 1000px;
  margin-top: 18px;
  border: 1px solid #e5e7eb;
  border-radius: 5px;
  overflow: hidden;
  padding: 15px;

  .fw-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .fw-label {
      font-size: 13px;
      color: #9ca3af;
    }

    .fw-refresh {
      font-size: 13px;
      color: #9ca3af;
      cursor: pointer;
      transition: color 0.15s;
      display: flex;
      align-items: center;
      &:hover { color: #374151; }
    }
  }

  /* ─── 图片 / 视频 网格 ─── */
  .fw-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;

    .fw-skeleton {
      aspect-ratio: 1;
      border-radius: 8px;
      background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%);
      background-size: 200% 100%;
      animation: shimmer 1.4s infinite;
    }

    .fw-cell {
      aspect-ratio: 1;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      position: relative;
      background: #f3f4f6;
      transition: transform 0.15s, box-shadow 0.15s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);

        .fw-cell-mask {
          opacity: 1;
        }
      }

        /* 音乐播放中时保持覆盖层可见 */
        &.fw-cell-playing .fw-cell-mask {
          opacity: 1;
        }

        .fw-thumb {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        /* 音乐封面背景（渐变色展开充满整格） */
        .fw-music-bg {
          width: 100%;
          height: 100%;
        }

        .fw-cell-mask {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.35);
          opacity: 0;
          transition: opacity 0.2s;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 6px;

          /* 音乐格常显视觉反馈 */
          &.fw-cell-mask-always {
            opacity: 0.7;
          }

          .fw-cell-play {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .fw-cell-user,
          .fw-cell-music-title {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.9);
            text-align: center;
            padding: 0 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 100%;
          }
        }
      }
    }

  .fw-empty {
    font-size: 13px;
    color: #9ca3af;
    text-align: center;
    padding: 20px 0;
  }
}

/* ─── 灯箱 / 视频弹层 ─── */
.fw-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.82);
  z-index: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fw-lb-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 90vw;
  max-height: 90vh;

  .fw-lb-img-box {
    overflow: hidden;
    max-width: 80vw;
    max-height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .fw-lb-img {
      max-width: 80vw;
      max-height: 70vh;
      object-fit: contain;
      transition: transform 0.2s;
      user-select: none;
    }
  }

  .fw-lb-toolbar {
    margin-top: 16px;
    display: flex;
    gap: 8px;
    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(8px);
    border-radius: 10px;
    padding: 8px 14px;
  }
}

.fw-video-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 90vw;

  .fw-video {
    max-width: 80vw;
    max-height: 70vh;
    border-radius: 8px;
    background: #000;
  }

  .fw-video-toolbar {
    margin-top: 14px;
    display: flex;
    gap: 8px;
    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(8px);
    border-radius: 10px;
    padding: 8px 14px;
  }
}

.fw-lb-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 34px;
  padding: 0 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.88);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover { background: rgba(255, 255, 255, 0.2); }

  &.fw-btn-same {
    color: #a78bfa;
    border-color: rgba(167, 139, 250, 0.4);
    &:hover { background: rgba(167, 139, 250, 0.15); }
  }

  &.fw-btn-close {
    color: #f87171;
    border-color: rgba(248, 113, 113, 0.3);
    &:hover { background: rgba(248, 113, 113, 0.12); }
  }
}

/* ─── 右下角迷你播放器 ─── */
.fw-mini-player {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 320px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  z-index: 500;

  .fw-mini-cover {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fw-mini-body {
    flex: 1;
    min-width: 0;

    .fw-mini-title {
      font-size: 13px;
      font-weight: 600;
      color: #111827;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 6px;
    }

    .fw-mini-progress {
      width: 100%;
      height: 4px;
      background: #e5e7eb;
      border-radius: 2px;
      cursor: pointer;
      margin-bottom: 3px;
      overflow: hidden;

      .fw-mini-fill {
        height: 100%;
        background: linear-gradient(90deg, #6366f1, #a855f7);
        border-radius: 2px;
        transition: width 0.3s linear;
      }
    }

    .fw-mini-times {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      color: #9ca3af;
    }
  }

  .fw-mini-actions {
    display: flex;
    align-items: center;
    gap: 2px;

    .fw-mini-btn {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      cursor: pointer;
      color: #374151;
      border-radius: 6px;
      transition: background 0.15s;

      &:hover { background: #f3f4f6; }
    }

    .fw-mini-btn-close {
      color: #ef4444;
      &:hover { background: #fff5f5; }
    }
  }
}

/* ─── 动画 ─── */
@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@keyframes fw-wave-dance {
  from { transform: scaleY(0.5); }
  to   { transform: scaleY(1.5); }
}
</style>
